import { render, staticRenderFns } from "./RuleSimple.vue?vue&type=template&id=6a63fe9c&"
import script from "./RuleSimple.vue?vue&type=script&lang=js&"
export * from "./RuleSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports